// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.request-reinbursement-custom-callout[data-v-11464b45] {\r\n  border-left: 4px solid #b5c3bc;\n}\r\n", ""]);
// Exports
module.exports = exports;
